import React from 'react';
import { Admin } from '@/types/admin';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import classNames from 'classnames';
import styled from 'styled-components';

import { getFullName } from '@/utils/name';

type Props = {
  admins: Admin[];
  value: number[];
  onChange: (data: CheckboxProps, adminId: number) => void;
  error?: boolean;
};
export const AdminCards: React.FC<Props> = ({
  admins,
  value,
  onChange,
  error,
}) => {
  return (
    <Wrapper>
      {admins.map((admin, i) => (
        <label
          data-test={`admin-${i}`}
          htmlFor={`admin-${admin.id}`}
          key={admin.id}
          className={classNames(
            'admin-card',
            error && 'error',
            value.includes(admin.id) && 'active',
          )}
        >
          <div className="checkbox-wrapper">
            <Checkbox
              id={`admin-${admin.id}`}
              checked={value.includes(admin.id)}
              onChange={(e, data) => onChange(data, admin.id)}
            />
          </div>
          <div className="profile">
            <div className="name">
              {getFullName(admin.firstName, admin.lastName)}
            </div>
            <div className="email">{admin.email}</div>
          </div>
        </label>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 6px 0;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 13.3px;

  .admin-card {
    width: 49%;
    padding: 22.8px 15.2px;
    display: flex;
    gap: 14px;
    border-radius: 5px;
    margin-bottom: 13.3px;
    cursor: pointer;

    background-color: white;
    box-shadow:
      0 1px 3px 0 #d4d4d5,
      0 0 0 1px #d4d4d5;
    border: 1px solid white;

    &.active {
      border-color: #2185d0;
      background-color: #f1f9ff;
    }

    &.error {
      background-color: #fff6f6;
      border: 1px solid #e0b4b4;
      color: #9f3a38;
    }

    &:hover {
      border-color: rgb(140, 175, 242);
      box-shadow: rgb(140, 175, 242) 0px 0px 1px;
    }

    &.error:hover {
      border: 1px solid #e0b4b4;
      box-shadow: rgb(140, 175, 242) 0px 0px 1px;
    }

    .checkbox-wrapper {
      display: flex;
      align-items: flex-end;

      padding-bottom: 7px;
      padding-left: 5px;
    }

    .profile {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 0;

      .name {
        font-weight: 700;
        line-height: 17.1px;
        font-size: 15.2px;
      }

      .email {
        font-size: 11.3px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.4);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;
